// Countdown Timer
document.addEventListener('DOMContentLoaded', function() {
    const countdownElements = document.querySelectorAll('.countdown-timer');
    countdownElements.forEach(function(element) {
        const unlockDate = new Date(element.dataset.unlockDate);

        function updateCountdown() {
            const now = new Date();
            const diff = unlockDate - now;

            if (diff <= 0) {
                element.innerHTML = 'Einheit ist jetzt verfügbar!';
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

            element.querySelector('.days').textContent = days;
            element.querySelector('.hours').textContent = hours;
            element.querySelector('.minutes').textContent = minutes;

            // Plural/Singular für die Zeiteinheiten
            element.querySelector('.days-text').textContent = days === 1 ? ' Tag' : ' Tage';
            element.querySelector('.hours-text').textContent = hours === 1 ? ' Stunde' : ' Stunden';
            element.querySelector('.minutes-text').textContent = minutes === 1 ? ' Minute' : ' Minuten';
        }

        updateCountdown();
        setInterval(updateCountdown, 60000); // Update jede Minute
    });
});
